export default __webpack_public_path__ + "static/media/InsideEyes_08.0a500747.png";